/** Brand semantic color mappings — primary/secondary/warm/cool/rarity/status/etc.
 *  Color values only (hex, rgba). CSS effects (box-shadow glow/borderGlow) stay in frontend. */
export const brandColors = {
  primary: {
    default: '#73A7EC',
    light: '#9CC0F1',
    dark: '#1F6DDB',
    glow: 'rgba(115, 167, 236, 0.6)',
  },
  secondary: {
    default: '#77CCE6',
    light: 'rgba(119, 204, 230, 0.1)',
    medium: 'rgba(119, 204, 230, 0.14)',
    faint: 'rgba(119, 204, 230, 0.06)',
    subtle: 'rgba(119, 204, 230, 0.18)',
    strong: 'rgba(119, 204, 230, 0.32)',
    dark: '#59A8C0',
    glow: 'rgba(119, 204, 230, 0.5)',
  },
  warm: {
    faint: 'rgba(208, 163, 66, 0.06)',
    light: 'rgba(208, 163, 66, 0.10)',
    medium: 'rgba(208, 163, 66, 0.16)',
    glow: 'rgba(208, 163, 66, 0.18)',
    strong: 'rgba(208, 163, 66, 0.24)',
    firm: 'rgba(208, 163, 66, 0.32)',
  },
  cool: {
    faint: 'rgba(140, 170, 210, 0.06)',
    light: 'rgba(140, 170, 210, 0.10)',
    medium: 'rgba(140, 170, 210, 0.16)',
    strong: 'rgba(140, 170, 210, 0.24)',
  },
  rarity: {
    common: '#B8C4D0',
    uncommon: '#6AC9AD',
    rare: '#6EB7E6',
    epic: '#B389D8',
    legendary: '#E3CD61',
    constellation: '#C98EC4',
  },
  status: {
    success: '#8ED382',
    successUltraFaint: 'rgba(142, 211, 130, 0.06)',
    successLight: 'rgba(142, 211, 130, 0.10)',
    successFaint: 'rgba(142, 211, 130, 0.15)',
    successGlow: 'rgba(142, 211, 130, 0.4)',
    successGlowStrong: 'rgba(142, 211, 130, 0.5)',
    warning: '#D0A342',
    // warning 표면·보더는 amber 계열의 .10/.19 알파를 유지한다.
    warningBg: 'rgba(208, 163, 66, 0.1)',
    warningBorder: 'rgba(208, 163, 66, 0.19)',
    error: '#E47C76',
    // 흰 글자를 얹는 채움용 진한 끝은 유지한다. error 전경·palette.red 는 틴트용이다.
    errorDark: '#C43F3F',
    errorBg: 'rgba(216, 98, 94, 0.1)',
    errorFaint: 'rgba(216, 98, 94, 0.15)',
    errorBorder: 'rgba(216, 98, 94, 0.19)',
    errorGlow: 'rgba(216, 98, 94, 0.3)',
    info: '#73A7EC',
    pending: '#A7ADF6',
    archived: '#94A3B8',
  },
  textHighlight: {
    scenario: '#D0A342',
    coin: '#D0A342',
  },
  medal: {
    gold: {
      base: 'rgba(255, 215, 0, 1)',
      faint: 'rgba(255, 215, 0, 0.1)',
      borderMedium: 'rgba(255, 215, 0, 0.25)',
    },
    silver: {
      base: 'rgba(192, 192, 192, 1)',
    },
    bronze: {
      base: 'rgba(205, 127, 50, 1)',
    },
  },
  overlay: {
    dark: 'rgba(0, 0, 0, 0.3)',
    darker: 'rgba(0, 0, 0, 0.4)',
    light: 'rgba(255, 255, 255, 0.05)',
    lighter: 'rgba(255, 255, 255, 0.08)',
  },
  badge: {
    primary: {
      background: 'rgba(115, 167, 236, 0.12)',
      border: 'rgba(115, 167, 236, 0.25)',
    },
    secondary: {
      background: 'rgba(119, 204, 230, 0.1)',
      border: 'rgba(119, 204, 230, 0.25)',
    },
  },
  card: {
    subtle: 'rgba(119, 204, 230, 0.04)',
  },
  glowColor: {
    coin: 'rgba(255, 215, 0, 0.3)',
  },
  agent: {
    dokkaebi: '#ff6b35',
  },
  point: {
    earn: '#4ADE80',
    grant: '#73A7EC',
    adjust: '#94A3B8',
  },
} as const;

export type BrandColors = typeof brandColors;
